module.exports = __webpack_public_path__ + "static/media/resume.cdd10c93.pdf";